import './styles/Leveraged.scss';
import lavarage from '../videos/lavarage.m4v';


function Leveraged() {


    return (
        <section className="leveraged" id="about">
            <div className="leveragedAnim">
                <video autoPlay muted loop playsInline>
                <source src={lavarage} type="video/mp4" />
                </video>
            </div>
            <div className="introductionContainer">
                <div className="introduction">
                    <h2 className="titleH2">
                        <span className="subtitle upText colorLightBlue">Paribus</span>
                        Interoperable Value Leveraged
                    </h2>
                    <p className="desc1">
                        As DeFi moves forward, innovators are uncovering
                        transformational ways to store and represent value on-chain.
                    </p>
                    <p className="desc1">
                        Paribus’ mission is to unlock the true potential of these
                        assets, evolving them into interoperable financial instruments,
                        capable of being used within DeFi protocols, on any chain.
                    </p>
                </div>
            </div>
        </section>
    )
}
            
export default Leveraged;